



































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import flagKeys from '@/constants/flagKeys';
import DateUtils from '@/utils/DateUtils';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';

type TriggerPosition = 'header' | 'footer';

@Component({
  components: {
    Typography,
    SelectionBox
  }
})
export default class CoinNetworkTerms extends Vue {
  @Prop() subscription!: any;

  billingAcceptance = false;

  observer: IntersectionObserver | null = null;
  triggerVisibility: Record<TriggerPosition, boolean> = {
    header: false,
    footer: false
  };

  get tPrefixTerms() {
    return 'terms.merchant.billing';
  }

  get tPrefix() {
    return 'modals.billing.acceptance.terms';
  }

  get description() {
    return String(this.$t(`${this.tPrefixTerms}`));
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get billingModuleV3() {
    return this.flags.includes(flagKeys.billingModuleV3);
  }

  get delayedPeriod() {
    return this.billingModuleV3 && this.subscription.eligibleForDelayPeriod;
  }

  get acceptanceBoxTerms() {
    const date = DateUtils.formattedDate({
      date: this.subscription.nextPaymentAt
    });

    if (this.delayedPeriod) {
      if (getNeedsOnboardingCall())
        return `I authorize Twism to mint 25 of my business' branded Coins per week for each registered or new location added starting ${
          this.subscription.defaultDelayPeriod
        } days after profile activation.`;
      return `I authorize Twism to mint 25 of my business' branded Coins per week for each registered or new location added starting on ${date}.`;
    }

    return 'I agree to allow Twism to mint Coins for my business at the rate of 25 Coins per week for each registered or new location I add for my business.';
  }

  handleTriggerObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const position = entry.target.getAttribute(
            'data-position'
          ) as TriggerPosition;
          this.triggerVisibility[position] =
            !entry.isIntersecting && !!position;
        }
      },
      {
        root: document.querySelector('.coin-network-terms'),
        rootMargin: '24px',
        threshold: 0
      }
    );

    const targets = document.querySelectorAll<HTMLElement>(
      '.coin-network-terms__body-trigger'
    );

    for (const target of targets) {
      this.observer.observe(target);
    }
  }

  mounted() {
    this.handleTriggerObserver();
  }
}
